import { reportFallbackBiEvent } from './bi';
export const webReporter = url => batchPayload => {
  try {
    const body = JSON.stringify({
      messages: batchPayload
    });
    const res = navigator.sendBeacon(url, body);
    if (!res) {
      fetch(url, {
        method: 'POST',
        body
      });

      // Report a BI event so we know this fallback occurred
      reportFallbackBiEvent(batchPayload, body);
      return true;
    }
    return res;
  } catch (e) {
    console.error(e);
    return false;
  }
};
//# sourceMappingURL=reporter.js.map